import React from 'react';
import { Link } from 'react-router-dom';
import { NavigationItem } from '../layout/Header'; // Import the type from Header

interface MobileNavigationProps {
    isOpen: boolean;
    onClose: () => void; // Added onClose prop
    navigationItems: readonly NavigationItem[];
}

const MobileNavigation: React.FC<MobileNavigationProps> = ({
    isOpen,
    onClose,
    navigationItems
}) => {
    if (!isOpen) return null;

    return (
        <div className="absolute top-full left-0 w-full bg-white dark:bg-neutral-900 shadow-lg md:hidden z-50">
            <nav className="px-4 py-2">
                <ul className="flex flex-col space-y-2">
                    {navigationItems.map(({ id, href, label, color }) => (
                        <li key={id}>
                            <Link
                                to={href}
                                className={`block text-xl font-bold ${color === 'text-secondary-red' ? 'text-secondary-red' :
                                        color === 'text-secondary-blue' ? 'text-secondary-blue' :
                                            'text-black dark:text-white'
                                    }`}
                                onClick={onClose} // Added onClick handler
                            >
                                {label}
                            </Link>
                        </li>
                    ))}
                </ul>
            </nav>
        </div>
    );
};

export default MobileNavigation;